module.exports = __webpack_public_path__ + "media/images/img-usage-button-4c4276b4f4d270ff5ad7c32dab130cd7.png";